import Controller from '@ember/controller';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import type { ConnectorType } from 'scaleflow/utils/connectors-config';
import type StoreService from 'scaleflow/services/store';
import { service } from '@ember/service';
import { HOST } from 'scaleflow/adapters/application';

export default class ConnectorsGithubController extends Controller {
  @service declare store: StoreService;

  declare model: { connector: ConnectorType; integrations: any[] };

  @tracked loading: boolean = false;

  get isPending() {
    return [...this.model.integrations].some(
      (i) =>
        i.provider_name === this.model.connector.id &&
        i.provider_id === 'pending',
    );
  }

  get isConnected() {
    return [...this.model.integrations].some(
      (i) =>
        i.provider_name === this.model.connector.id &&
        i.provider_id !== 'pending',
    );
  }

  async createIntegrationSetting(providerId: string) {
    const adapter = this.store.adapterFor('application') as any;
    const json = await adapter.ajax(`${HOST}/integration-settings`, 'POST', {
      data: {
        data: {
          type: 'integration-settings',
          attributes: { provider_name: providerId },
        },
      },
    });
    return json;
  }

  @action
  async initiateInstall() {
    this.loading = true;
    const { meta } = await this.createIntegrationSetting(
      this.model.connector.id,
    );
    const install_url: string = meta?.install_url;
    if (!install_url)
      throw new Error(
        'No install url received for installation initiate event',
      );

    this.redirect(install_url);
  }

  redirect(url: string) {
    window.open(url, '_blank', 'noopener,noreferrer');
  }
}
